// 头像分享
<template>
	<div v-if="showFlag" class="as-container">
		<div class="header-box"></div>
		<div class="content-area">
			<div class="content-area-wapper">
				<div class="title">
					<span style="margin-right: 10px" v-html="uname"></span>喜提2022新头像
				</div>
				<div class="tx-img">
					<img :src="txImg" />
				</div>
				<div class="opt-btns">
					<div class="btn" @touchstart="touchStart" @touchend="touchEnd">
						<div class="btn-1">长按头像保存</div>
						<!-- <img ref="saveRef" :src="txImg" /> -->
					</div>
					<div class="two-b">
						<div class="tw-btn" @click="callbackBtn"></div>
						<div class="tw-btn" @click="shearFlag = true"></div>
					</div>
				</div>
				<div class="cy-poeople">
					<div class="cp-area">
						<div style="display: flex">
							<div v-for="(item, index) in cyList" :key="index" class="cy-tx">
								<img :src="item.img" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="foot-box"></div>
		<div v-if="shearFlag" class="shear-mask" @click="shearFlag = false"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				txImg: '',
				loopTimer: null,
				uname: '',
				cyList: [],
				showFlag: false,
				shearFlag: false,
				isSaveImg: false,
			}
		},
		created() {
			this.txImg = localStorage.getItem('canvasImg')
			if (localStorage.getItem('avatarSharing')) {
				let data = localStorage.getItem('avatarSharing')
				this.uname = data || ''
			} else {
				localStorage.setItem('avatarSharing', this.$route.params.uname)
				this.uname = this.$route.params.uname || ''
			}

			if (this.txImg && this.uname) {
				this.showFlag = true
				this.getCyDataList()
				let saveImg = localStorage.getItem('saveImg')
				if (saveImg == this.txImg) {
					this.isSaveImg = true
				} else {
					this.isSaveImg = false
				}
				this.blobToDataURL(this.txImg)
			}
		},
		methods: {
			// click1() {
			// 	this.$toast('用户头像获取失败')
			// 	this.saveImg(this.$route.query.img)
			// 	this.blobToDataURL(this.$route.query.img)
			// },

			getCyDataList() {
				let formData = new FormData()
				formData.append('way', 'lists')
				this.$http
					.post(`${this.$BASE_URL}/_vip`, formData, {
						headers: { 'content-type': 'application/x-www-form-urlencoded' },
					})
					.then(res => {
						if (res.data && res.data.error == 0) {
							this.cyList = res.data.data
						} else {
							this.$toast('参与数据获取失败')
						}
					})
					.catch(error => {
						console.log(error)
						this.$toast('参与数据获取失败')
					})
			},

			touchStart(e) {
				e.preventDefault()
				// let _self = this
				// _self.$toast('用户头像获取失败1')
				// this.loopTimer = setTimeout(() => {
				// 	_self.saveImg()
				// 	_self.blobToDataURL(this.txImg)
				// }, 1000)
			},
			touchEnd(e) {
				e.preventDefault()
				// clearTimeout(this.loopTimer)
			},
			// 保存图片
			saveImg(imgUrl) {
				const a = document.createElement('a')
				a.download = 'tx'
				a.style.display = 'none'
				a.href = imgUrl
				document.body.appendChild(a)
				a.touchstart()
				a.remove()
				window.URL.revokeObjectURL(imgUrl)
			},

			blobToDataURL(blob) {
				const image = new Image()
				image.src = blob
				image.onload = () => {
					const canvas = document.createElement('canvas')
					canvas.width = image.width
					canvas.height = image.height
					const context = canvas.getContext('2d')
					context.drawImage(image, 0, 0, image.width, image.height)
					let imgUrl = canvas.toDataURL()
					console.log(imgUrl)
					// this.saveImgInServer(imgUrl)
				}
			},
			callbackBtn() {
				this.showFlag = false
				localStorage.removeItem('avatarSharing')
				let vdata = localStorage.getItem('vdata')
				localStorage.removeItem('vdata')
				this.$router.replace({
					path: `/immediate-extraction?vdata=${vdata}`,
				})
			},
		},
	}
</script>
<style lang="scss" scoped>
	.as-container {
		z-index: 100;
		user-select: none;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		div {
			user-select: none;
			-webkit-appearance: none !important;
		}
		width: 10rem;
		height: 100vh;
		position: relative;
		.header-box {
			height: 2.6rem;
			width: 100%;
			background: url('/style/assets/image/p5/header.png')
				no-repeat;
			background-size: 100% 100%;
		}
		.content-area {
			height: 100%;
			width: 100%;
			background: url('/style/assets/image/p5/bg.png')
				no-repeat;
			background-size: 100% 77.211%;
			.content-area-wapper {
				width: 100%;
				display: flex;
				align-items: center;
				flex-direction: column;
				.title {
					font-family: SourceHanSansCN-Bold;
					margin-top: 0.333333rem;
					color: #64360d;
					font-size: 0.526667rem;
					font-weight: bold;
					margin-bottom: 0.33333rem;
				}
				.tx-img {
					width: 5.666667rem;
					// height: 5.666667rem;
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 90%;
						height: 90%;
					}
				}
				.opt-btns {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-top: 0.333333rem;
					.btn:nth-child(1) {
						height: 1.266667rem;
						width: 4.533333rem;
						border: none;
						position: relative;
						user-select: none;
						-webkit-touch-callout: none;
						.btn-1 {
							width: 100%;
							height: 100%;
							position: absolute;
							top: 0;
							left: 0;
							background: url('/style/assets/image/btn_1.png')
								no-repeat;
							background-size: 100% 100%;
							user-select: none;
							-webkit-touch-callout: none;
							user-select: none;
							color: #fff;
							font-size: 0.53rem;
							font-weight: bold;
							display: flex;
							align-items: center;
							justify-content: center;
						}
						img {
							width: 100%;
							height: 100%;
							position: absolute;
							top: 0;
							left: 0;
							opacity: 0;
							background-color: transparent;
							visibility: hidden;
							z-index: 1;
						}
					}
					.two-b {
						display: flex;
						align-items: center;
						margin-top: 0.333333rem;
						.tw-btn {
							width: 4.533333rem;
							height: 1.5rem;
							margin-top: 0.266667rem;
							margin: 0 0.066667rem;
						}
						.tw-btn:nth-child(1) {
							background: url('/style/assets/image/back-btn.png')
								no-repeat;
							background-size: 100% 100%;
							height: 1.3rem;
						}
						.tw-btn:nth-child(2) {
							background: url('/style/assets/image/shrea-btn.png')
								no-repeat;
							height: 1.3rem;
							background-size: 100% 100%;
						}
					}
				}
				.cy-poeople {
					margin-top: 0.533333rem;
					width: 8.533333rem;
					height: 2rem;
					background: url('/style/assets/image/p5/cy.png')
						no-repeat;
					background-size: 100% 100%;
					position: relative;
					.cp-area {
						width: 5.8rem;
						height: 1.333333rem;
						position: absolute;
						right: 0.2rem;
						bottom: 0.25rem;
						display: flex;
						align-items: center;
						overflow-y: hidden;
						overflow-x: auto;
						-webkit-overflow-scrolling: touch;
						.cy-tx {
							margin: 0 0.133333rem;
							background-color: #fff;
							width: 1rem;
							height: 1rem;
							border-radius: 0.053333rem;
							img {
								height: 100%;
								width: 100%;
								border-radius: 0.08rem;
							}
						}
					}
				}
			}
		}
		.foot-box {
			height: 1.466667rem;
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;
			background: url('/style/assets/image/p5/foot-box.png')
				center center no-repeat;
			background-size: 6rem 0.6rem;
		}
		.shear-mask {
			height: 100vh;
			width: 100vw;
			position: fixed;
			top: 0;
			left: 0;
			background: url('/style/assets/image/yd-bg.07e8d9bc.png')
				no-repeat;
			background-size: 100% 100%;
		}
	}
</style>
